module.exports = __webpack_public_path__ + "static/media/hamburger.ab910ad9.svg";